import type { DataPoint } from '../types/dashboard';

export const mockDatasets: Record<string, DataPoint[]> = {
  'dataset-line-error-acumulado': [
    { periodo: 'P1', errorTonelaje: 2.1, errorLey: 1.5, errorMetal: 3.2 },
    { periodo: 'P2', errorTonelaje: 4.5, errorLey: 2.8, errorMetal: 5.1 },
    { periodo: 'P3', errorTonelaje: 5.2, errorLey: 3.1, errorMetal: 6.8 },
    { periodo: 'P4', errorTonelaje: 7.8, errorLey: 4.2, errorMetal: 8.5 },
    { periodo: 'P5', errorTonelaje: 8.1, errorLey: 5.5, errorMetal: 10.2 },
    { periodo: 'P6', errorTonelaje: 9.5, errorLey: 6.1, errorMetal: 11.8 },
  ],

  'dataset-scatter-acierto-ley-corte': Array.from({ length: 80 }, (_, i) => {
    const leyLP = Math.random() * 1.5 + 0.3;
    const scatter = (Math.random() - 0.5) * 0.4;
    return {
      bloque: `BLK-${i + 1}`,
      leyLP: parseFloat(leyLP.toFixed(3)),
      leyCP: parseFloat((leyLP + scatter).toFixed(3)),
    };
  }),

  'dataset-line-error-periodo': [
    { periodo: 'P1', errorTonelaje: 2.1, errorLey: -1.5, errorMetal: 0.8 },
    { periodo: 'P2', errorTonelaje: -3.2, errorLey: 2.1, errorMetal: -1.2 },
    { periodo: 'P3', errorTonelaje: 1.8, errorLey: -0.5, errorMetal: 2.5 },
    { periodo: 'P4', errorTonelaje: -2.5, errorLey: 1.8, errorMetal: -0.8 },
    { periodo: 'P5', errorTonelaje: 4.1, errorLey: -2.2, errorMetal: 1.5 },
    { periodo: 'P6', errorTonelaje: -1.2, errorLey: 0.8, errorMetal: -2.1 },
  ],

  'dataset-line-comparacion-periodo': [
    { periodo: 'P1', tonelajeLP: 1250, tonelajeCP: 1180 },
    { periodo: 'P2', tonelajeLP: 1340, tonelajeCP: 1420 },
    { periodo: 'P3', tonelajeLP: 1180, tonelajeCP: 1150 },
    { periodo: 'P4', tonelajeLP: 1420, tonelajeCP: 1380 },
    { periodo: 'P5', tonelajeLP: 1550, tonelajeCP: 1620 },
    { periodo: 'P6', tonelajeLP: 1280, tonelajeCP: 1310 },
  ],

  'dataset-line-acierto-destino': [
    { rangoLey: '0.0-0.3', acierto: 92 },
    { rangoLey: '0.3-0.5', acierto: 78 },
    { rangoLey: '0.5-0.7', acierto: 65 },
    { rangoLey: '0.7-0.9', acierto: 71 },
    { rangoLey: '0.9-1.2', acierto: 84 },
    { rangoLey: '>1.2', acierto: 95 },
  ],

  'dataset-spatial-acierto-destino': [
    { x: 23.5, y: 27.4, clasificacion: 'ORO -> WASTE(ERROR)' },
    { x: 23.6, y: 27.3, clasificacion: 'ORO -> WASTE(ERROR)' },
    { x: 23.7, y: 27.2, clasificacion: 'ORO -> WASTE(ERROR)' },
    { x: 23.8, y: 27.0, clasificacion: 'ORO -> WASTE(ERROR)' },
    { x: 23.9, y: 26.8, clasificacion: 'ORO -> WASTE(ERROR)' },
  ],
};
